/**
 * Shim fino — delega para `@pps/observability` (IR-OBS-006).
 */
import { initLogger, getErrorMessage } from "@pps/observability";

export const logger = initLogger({ app: "crm" });
export { getErrorMessage };
